import { Add, Close } from "@mui/icons-material";
import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
import TextFieldControl from "components/form/TextFieldControl";
import { Control, useFieldArray } from "react-hook-form";
import { QuestionInputs } from "../types";

interface CriterionProps {
  control: Control<QuestionInputs>;
  disabled?: boolean;
}

const Criterion = ({ control, disabled }: CriterionProps) => {
  const {
    fields: criterionFields,
    append: appendCriteria,
    remove,
  } = useFieldArray({
    control,
    keyName: "formId",
    name: "criterion",
  });

  return (
    <Box>
      <Stack spacing={2}>
        <Stack
          direction='row'
          spacing={2}
          justifyContent='space-between'
          alignItems='flex-end'>
          <Typography
            variant='body14rg'
            color='text.secondary'>
            Критерии оценки ответа
          </Typography>
          <Typography
            variant='body16rg'
            color='primary.main'
            sx={{ py: 1, px: 2, borderRadius: 2, backgroundColor: "bgSwitch" }}>
            Количество критериев: {criterionFields.length}
          </Typography>
        </Stack>
        {criterionFields.map((field, index) => (
          <TextFieldControl
            multiline
            maxRows={4}
            endIcon={
              criterionFields?.length > 1 && (
                <IconButton
                  onClick={() => remove(index)}
                  disabled={disabled}>
                  <Close sx={{ color: "base.200" }} />
                </IconButton>
              )
            }
            key={field.formId}
            name={`criterion.${index}.value`}
            rules={{ required: true }}
            disabled={disabled}
            placeholder='Текст критерия оценки'
            sx={{
              "& > .MuiInputBase-root": {
                backgroundColor: "white",
              },
              "& .MuiInputAdornment-root ": {
                alignItems: "flex-end",
                height: 24,
              },
            }}
          />
        ))}
      </Stack>
      <Button
        disabled={disabled}
        startIcon={<Add />}
        sx={({ typography }) => ({
          px: 0,
          justifyContent: "flex-start",
          color: "base.200",
          ...typography.body14rg,
        })}
        onClick={() => appendCriteria({ value: "" })}>
        критерий оценки
      </Button>
    </Box>
  );
};

export default Criterion;
